import { lazy } from "react";

import { app } from "~/helpers/routes";
import { paths } from "~/router/paths";

const adsVersion: string = import.meta.env.VITE_ADS_VERSION || "v1";

const AdsWriterPage = lazy(() =>
  adsVersion === "v2"
    ? import("~/pages/v2/ads-writer")
    : import("~/pages/ads-writer")
);

const GeneratePage = lazy(() =>
  adsVersion === "v2"
    ? import("~/pages/v2/ads-writer/generate")
    : import("~/pages/ads-writer/generate")
);

export const routes: Array<any> = [
  {
    path: paths.ads.index,
    element: app(AdsWriterPage),
  },
  {
    path: paths.ads.generate,
    element: app(GeneratePage),
  },
];
